import {
  css as originalCss,
  default as originalStyled,
  FlattenInterpolation,
  ThemedCssFunction,
  ThemedStyledInterface,
  ThemedStyledProps,
} from 'styled-components';
import { Theme } from './styles/general/theme';
import { opelTheme } from './styles/opel/opel-theme';

export const defaultTheme: Theme = opelTheme;

export interface ThemeProps {
  theme?: Theme;
}

type DWTStyledInterface = ThemedStyledInterface<Theme>;

export const styled: DWTStyledInterface = originalStyled as any;
export const css: ThemedCssFunction<Theme> = originalCss;

export type StyledProps<P> = P & ThemeProps;

export const IEOnly = (styles: string | FlattenInterpolation<ThemedStyledProps<any, Theme>>) => css`
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    ${styles}
  }
`;
